<script setup>
import { $t } from "~/utils/index.js";
import ImageZoom from 'js-image-zoom'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'


const props = defineProps({
  options: {
    type: Object,
    default: () => ({})
  }
})

const vueImageZoom = ref(null)
let imageZoom = null
let observer = null

function configureImages(container) {
  const images = container.querySelectorAll('img')
  images.forEach(img => {
    if (!img.referrerPolicy) {
      img.referrerPolicy = 'no-referrer'
    }

    // js-image-zoom 会同时写入固定宽高；详情主图需要通过 object-fit
    // 保持原图比例，避免竖图或横图被强制拉伸成正方形。
    if (props.options.imageFit) {
      img.style.objectFit = props.options.imageFit
      img.style.objectPosition = props.options.imagePosition || 'center center'
      img.style.display = 'block'
    }
  })
}

function rerenderImageZoom() {
  if (vueImageZoom.value) {
    const img = new Image()
    img.src = props.options.img
    img.referrerpolicy = "no-referrer"
    img.onload = () => {
      imageZoom = new ImageZoom(vueImageZoom.value, { ...props.options });
      
      // 确保初始图片有 no-referrer 属性
      configureImages(vueImageZoom.value)
      
      // 监听 DOM 变化，确保动态创建的图片也有 no-referrer 属性
      if (observer) {
        observer.disconnect()
      }
      
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'IMG') {
                  node.referrerPolicy = 'no-referrer'
                  configureImages(vueImageZoom.value)
                } else {
                  configureImages(node)
                }
              }
            })
          }
        })
      })
      
      observer.observe(vueImageZoom.value, {
        childList: true,
        subtree: true
      })
    }
  }
}

function kill() {
  imageZoom?.kill()
  if (observer) {
    observer.disconnect()
    observer = null
  }
}

onMounted(() => {
  rerenderImageZoom()
})

onBeforeUnmount(() => {
  kill()
})

watch(() => props.options, () => {
  kill()
  rerenderImageZoom()
})

</script>

<template>
  <div ref="vueImageZoom" class="vue-image-zoom" w-full h-full relative />
</template>

<style>
.vue-image-zoom:first-child img {
  border-radius: 12px;
  margin: 0 auto;
}
</style>
